import React, { useEffect, useState } from "react";
import classes from "./NotificationSettings.module.scss";
import Input from "../../../../components/Common/Input/Input";
import { FormProvider, useForm } from "react-hook-form";
import {
  createSeries,
  notificationSettingsSchema,
} from "../../../../utils/mainTabs/distribute/createSeries";
import Button from "../../../../components/Common/Button/Button";
import Tooltip from "../../../../components/Common/ToolTip/Tooltip";
import InfoIcon from "../../../../components/Common/SvgIcons/SocialIcons/InfoIcon";
import {
  useLocation,
  useNavigate,
  useOutletContext,
  useParams,
} from "react-router";
import { yupResolver } from "@hookform/resolvers/yup";
import PreviousIcon from "../../../../components/Common/SvgIcons/CommonIcons/PreviousIcon";
import { useSelector } from "react-redux";
import { mode } from "../../../../utils/formModes";
import { FormattedMessage } from "react-intl";

const NotificationSettings = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();
  const { formValues, setFormValues, tenantName } = useOutletContext();
  const { formFields } = createSeries.notificationSettings;
  const [fields, setFields] = useState([]);
  const methods = useForm({
    defaultValues: formValues,
    resolver: yupResolver(notificationSettingsSchema),
  });
  const {
    handleSubmit,
    setValue,
    reset,
    formState: { errors },
  } = methods;
  const commonState = useSelector((state) => state.commonReducer);
  const { colors } = commonState;
  const distributeState = useSelector((state) => state.distributeReducer);
  const { classAndCollectionDataByProgramId } = distributeState;

  useEffect(() => {
    setFields(
      formFields(
        location.pathname ===
          `${createSeries.copyPath(tenantName)}/${
            params?.programId
          }/notificationSettings`
          ? mode.COPY
          : mode.ADD
      )
    );
  }, [formFields, location, params, tenantName]);

  useEffect(() => {
    if (classAndCollectionDataByProgramId?.length > 0) {
      const programData = classAndCollectionDataByProgramId?.[0].Programs;
      setValue(
        "NoDaysToNotifyBeforeDueDate",
        programData?.NoDaysToNotifyBeforeDueDate
      );
    }
  }, [classAndCollectionDataByProgramId, setValue]);

  const onSubmit = (data) => {
    setFormValues({ ...formValues, ...data });
    if (
      location.pathname ===
      `${createSeries.copyPath(tenantName)}/${
        params?.programId
      }/notificationSettings`
    )
      navigate(
        `${createSeries.copyPath(tenantName)}/${
          params?.programId
        }/certificateSettings`
      );
    else if (
      location.pathname ===
      `${createSeries.editPath(tenantName)}/${
        params?.programId
      }/notificationSettings`
    )
      navigate(
        `${createSeries.editPath(tenantName)}/${
          params?.programId
        }/certificateSettings`
      );
    else navigate(createSeries.certificateSettings.path(tenantName));
  };

  const previousClick = () => {
    if (
      location.pathname ===
      `${createSeries.copyPath(tenantName)}/${
        params?.programId
      }/notificationSettings`
    )
      navigate(
        `${createSeries.copyPath(tenantName)}/${
          params?.programId
        }/seriesDetails`
      );
    else if (
      location.pathname ===
      `${createSeries.editPath(tenantName)}/${
        params?.programId
      }/notificationSettings`
    )
      navigate(
        `${createSeries.editPath(tenantName)}/${
          params?.programId
        }/seriesDetails`
      );
    else navigate(createSeries.distributionDetails.path(tenantName));
  };

  return (
    <FormProvider {...methods}>
      <form
        className={classes.notification_settings}
        onSubmit={handleSubmit(onSubmit)}
      >
        <div className={classes.form}>
          {fields.map((item) => {
            return (
              <Input
                key={item.key}
                label={item.label}
                name={item.name}
                type={item.type}
                labelColor={item.labelColor}
                width={item.width}
                required={item.required}
                min={item.min}
                max={item.max}
                error={errors?.[item?.name]?.message}
                fieldName={item?.fieldName}
                fieldValue={item?.fieldValue}
                disabled={
                  formValues?.CanDisplayClassPostDuedate ? true : item?.disable
                }
              />
            );
          })}
          <div className={classes.info}>
            <FormattedMessage id="DISTRIBUTE_PRG_NOTIFICATION_TEXT2" />
            <div className={classes.icon}>
              <Tooltip
                direction="right"
                content="Learner will get notification before selected day/days before course expires."
              >
                <InfoIcon />
              </Tooltip>
            </div>
          </div>
        </div>
        {formValues?.CanDisplayClassPostDuedate && (
          <div className={classes.disabled_info}>
            Note: This field is disabled because "Do not Use Duedate" field is
            selected.
          </div>
        )}
        <div className={classes.footer}>
          <div className={classes.previous}>
            <PreviousIcon fill={colors.theme} />
            <span className={classes.previous_text} onClick={previousClick}>
              <FormattedMessage id="PAGINATION_PREVIOUS" />
            </span>
          </div>
          <div className={classes.btn}>
            <div className={classes.clear_all} onClick={() => reset()}>
              {" "}
              <FormattedMessage id="CLEAR_ALL_TXT" />
            </div>
            <Button
              label={
                formValues?.CanDisplayClassPostDuedate ? "Next" : "Save & Next"
              }
              small
              dark
              type="submit"
            />
          </div>
        </div>
      </form>
    </FormProvider>
  );
};

export default NotificationSettings;
